module.exports = __webpack_public_path__ + "static/img/all-banner3.ab4f002.png";


//////////////////
// WEBPACK FOOTER
// ./static/pawnProducts/all-banner3.png
// module id = pcOi
// module chunks = 1